"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ConfiguratorCarousel = void 0;

var _configuratorCarousel = _interopRequireDefault(require("./components/configurator-carousel"));

exports.ConfiguratorCarousel = _configuratorCarousel["default"];